define('models/shared/user/roleaccess_collection',["backbone",
        "models/shared/user/roleaccess"
], function (Backbone, RoleAccess) {
    var RolesAccess = Backbone.Collection.extend({
        model: RoleAccess,
        initialize: function (attributes, options) {
            options || (options = {});
        }
    });
    return RolesAccess;
});

